var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaskGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 119,
    viewBox: "0 0 382 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1228_3588",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 382,
    height: 119
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 380,
    height: 117,
    rx: 17,
    fill: "#D8FBDB",
    stroke: "black",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1228_3588)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0 176.943V28.1149C0 18.9431 11.3165 14.6098 17.4424 21.4358L139.558 157.507C145.684 164.333 157 160 157 150.828V28.1149C157 18.9431 168.316 14.6098 174.442 21.4358L296.558 157.507C302.684 164.333 314 160 314 150.828V28.1149C314 18.9431 325.316 14.6098 331.442 21.4358L453.558 157.507C459.684 164.333 471 160 471 150.828V2",
    stroke: "#161F21",
    strokeWidth: 36
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskGroup);
export default __webpack_public_path__ + "static/media/Mask_group.35acb7c2f173538fb36cc6379d27a3f6.svg";
export { ForwardRef as ReactComponent };